import { SERVICES } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Services = () => (
    <section id="services" data-testid="services-section" className="bg-mist py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <SectionHeading
                number="02"
                eyebrow="Our Services"
                title="Dental Care,"
                accent="End to End"
                sub="From routine check-ups to complete smile restoration — clear, comfortable care for every need."
            />
            <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.title} delay={(i % 4) * 0.07}>
                        <article
                            data-testid={`service-card-${i}`}
                            className="group h-full rounded-3xl border border-ink/5 bg-white p-6 transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-teal-600/30 hover:shadow-[0_24px_50px_-20px_rgba(13,148,136,0.35)]"
                        >
                            <span className="grid h-12 w-12 place-items-center rounded-2xl bg-mist text-teal-700 transition-[background-color,color] duration-500 group-hover:bg-teal-accent group-hover:text-white">
                                <s.icon className="h-5 w-5" />
                            </span>
                            <h3 className="mt-5 font-display text-xl leading-snug text-ink">{s.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
